import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "../../styles/GlobalStyles.css";


const AdminEditCandidate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    alternate_no: "",
    gender: "",
    date_of_birth: "",

    address: {
      street: "",
      area: "",
      city: "",
      state: "",
      postal_code: "",
      country: "",
    },

    work_preference: {
      experience: "",

      notice_period: "",
      preferred_location: "",
    },
  });

  /* ================= FETCH CANDIDATE ================= */

  useEffect(() => {
    const fetchCandidate = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/profile/allCandidates`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const candidate = res.data.candidates.find(c => c._id === id);
        if (!candidate) {
          alert("Candidate not found");
          return navigate("/admin/manage-users");
        }

        setForm({
          first_name: candidate.first_name || "",
          last_name: candidate.last_name || "",
          email: candidate.email || "",
          phone_number: candidate.phone_number || "",
          alternate_no: candidate.alternate_no || "",
          gender: candidate.gender || "",
          date_of_birth: candidate.date_of_birth
            ? candidate.date_of_birth.split("T")[0]
            : "",

          address: {
            street: candidate.address?.street || "",
            area: candidate.address?.area || "",
            city: candidate.address?.city || "",
            state: candidate.address?.state || "",
            postal_code: candidate.address?.postal_code || "",
            country: candidate.address?.country || "",
          },

          work_preference: {
            experience: candidate.work_preference?.experience || "",

            notice_period: candidate.work_preference?.notice_period || "",
            preferred_location: candidate.work_preference?.preferred_location || "",
          },
        });

        setLoading(false);
      } catch (err) {
        console.error(err);
        alert("Failed to load candidate");
      }
    };
    fetchCandidate();
  }, [id, navigate]);

  /* ================= HANDLE CHANGE ================= */

  const handleChange = (e, path) => {
    const value = e.target.value;

    if (path.includes(".")) {
      const [parent, key] = path.split(".");
      setForm(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [key]: value,
        },
      }));
    } else {
      setForm(prev => ({ ...prev, [path]: value }));
    }
  };

  /* ================= SAVE ================= */

  const handleSave = async () => {
    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/admin/updateCandidate/${id}`,
        form,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      alert("Candidate updated successfully");
      navigate("/admin/manage-users");
    } catch (err) {
      console.error(err);
      alert("Failed to update candidate");
    }
  };

  if (loading) return <p className="p-6">Loading...</p>;

  /* ================= UI ================= */

  return (
    <>
      {/* ===== BACKDROP ===== */}
      <div
        className="profile-backdrop"
        onClick={() => navigate("/admin/manage-users")}
      />

      {/* ===== DRAWER ===== */}
      <div className="profile-drawer admin-edit-drawer">
        <button
          className="drawer-close-btn"
          onClick={() => navigate("/admin/manage-users")}
        >
          ✕
        </button>

        <div className="profile-container admin-profile-container">
          <h2 className="profile-title">Edit Candidate</h2>

          {/* ================= PERSONAL INFO ================= */}
          <div className="profile-section">
            <h3>Personal Information</h3>

            <div className="profile-row">
              <input
                className="profile-input"
                value={form.first_name}
                onChange={(e) => handleChange(e, "first_name")}
                placeholder="First Name"
              />

              <input
                className="profile-input"
                value={form.last_name}
                onChange={(e) => handleChange(e, "last_name")}
                placeholder="Last Name"
              />
            </div>

            <div className="profile-row">
              <input
                className="profile-input"
                value={form.email}
                disabled
                placeholder="Email (readonly)"
              />

              <input
                className="profile-input"
                value={form.phone_number}
                onChange={(e) => handleChange(e, "phone_number")}
                placeholder="Phone Number"
              />
            </div>

            <div className="profile-row">
              <input
                className="profile-input"
                value={form.alternate_no}
                onChange={(e) => handleChange(e, "alternate_no")}
                placeholder="Alternate Number"
              />

              <input
                type="date"
                className="profile-input"
                value={form.date_of_birth}
                onChange={(e) => handleChange(e, "date_of_birth")}
              />
            </div>
          </div>

          {/* ================= ADDRESS ================= */}
          <div className="profile-section">
            <h3>Address</h3>

            <div className="profile-row">
              <input
                className="profile-input"
                value={form.address.street}
                onChange={(e) => handleChange(e, "address.street")}
                placeholder="Street"
              />

              <input
                className="profile-input"
                value={form.address.area}
                onChange={(e) => handleChange(e, "address.area")}
                placeholder="Area"
              />
            </div>

            <div className="profile-row">
              <input
                className="profile-input"
                value={form.address.city}
                onChange={(e) => handleChange(e, "address.city")}
                placeholder="City"
              />

              <input
                className="profile-input"
                value={form.address.state}
                onChange={(e) => handleChange(e, "address.state")}
                placeholder="State"
              />
            </div>

            <div className="profile-row">
              <input
                className="profile-input"
                value={form.address.postal_code}
                onChange={(e) => handleChange(e, "address.postal_code")}
                placeholder="Postal Code"
              />

              <input
                className="profile-input"
                value={form.address.country}
                onChange={(e) => handleChange(e, "address.country")}
                placeholder="Country"
              />
            </div>
          </div>

          {/* ================= WORK PREFERENCES ================= */}
          <div className="profile-section">
            <h3>Work Preferences</h3>

            <div className="profile-row">
              <input
                className="profile-input"
                value={form.work_preference.experience}
                onChange={(e) =>
                  handleChange(e, "work_preference.experience")
                }
                placeholder="Total Experience (Years)"
              />


            </div>

            <div className="profile-row">
              <input
                className="profile-input"
                value={form.work_preference.notice_period}
                onChange={(e) =>
                  handleChange(e, "work_preference.notice_period")
                }
                placeholder="Notice Period (Days)"
              />

              <input
                className="profile-input"
                value={form.work_preference.preferred_location}
                onChange={(e) =>
                  handleChange(e, "work_preference.preferred_location")
                }
                placeholder="Preferred Job Location"
              />
            </div>
          </div>

          {/* ================= ACTIONS ================= */}
          <div className="profile-actions">
            <button className="profile-save-btn" onClick={handleSave}>
              Save Changes
            </button>

            <button
              className="profile-cancel-btn"
              onClick={() => navigate("/admin/manage-users")}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );


};

export default AdminEditCandidate;
